import { useDialogContentContext } from "./DialogContent.context";

function useIsInsideDialog() {
  const contextValue = useDialogContentContext();
  return !!contextValue;
}

export { useIsInsideDialog };
